import React, { lazy, Suspense } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
//import Dashboard from "./dashboard";
//import Donor from './donor';
const Dashboard = lazy(() => import("./dashboard"));
const Donor = lazy(() => import("./donor"));
const Charity = lazy(() => import("./charity"));
const Volunteer = lazy(() => import("./volunteer"));
const LocalAdmin = lazy(() => import("./localAdmin"));
const Donation = lazy(() => import("./donation"));
const Regions = lazy(() => import("./regions"));
const Payments = lazy(() => import("./payments"));
const Settings = lazy(() => import("./settings"));
const TeamMembers = lazy(() => import("./teamMembers"));
const Admin = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Suspense fallback={<div className="spin">Loading...</div>}>
        <Route path={path} component={Dashboard} />
        <Route path={`${path}/donor`} component={Donor} />
        <Route path={`${path}/charity`} component={Charity} />
        <Route path={`${path}/volunteer`} component={Volunteer} />
        <Route path={`${path}/local-admin`} component={LocalAdmin} />
        <Route path={`${path}/donations`} component={Donation} />
        <Route path={`${path}/regions`} component={Regions} />
        <Route path={`${path}/payments`} component={Payments} />
        <Route path={`${path}/settings`} component={Settings} />
        <Route path={`${path}/team`} component={TeamMembers} />
      </Suspense>
    </Switch>
  );
};

export default Admin;
